import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=3cc21dc0&scoped=true&"
import script from "./Sponsor.vue?vue&type=script&lang=js&"
export * from "./Sponsor.vue?vue&type=script&lang=js&"
import style0 from "./Sponsor.vue?vue&type=style&index=0&id=3cc21dc0&lang=scss&scoped=true&"
import style1 from "./Sponsor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc21dc0",
  null
  
)

component.options.__file = "Sponsor.vue"
export default component.exports